import { applyPlacementCalculation, synchronizePlacementInputs, calculatePlacementFee, getValue, putValue, placementPayBasis, PLACEMENT_SALARY, FEE_MODE, FEE_PERCENT, FEE_AMOUNT, FEE_PERCENT_UNIT, HOURS_PER_WEEK, PLACEMENT_DERIVED_PATHS } from '../../../../backend/src/services/ncfFinancials.mjs';

export const WORKSHEET_PATHS = [PLACEMENT_SALARY, FEE_MODE, FEE_PERCENT, FEE_AMOUNT, HOURS_PER_WEEK, FEE_PERCENT_UNIT];

export default function NcfPlacementWorksheet({ root, fields = [], onChange, disabled = false }) {
  const basis = placementPayBasis(root, fields);
  const mode = getValue(root, FEE_MODE) || 'imported';
  const salary = getValue(root, PLACEMENT_SALARY) ?? '';
  const percent = getValue(root, FEE_PERCENT) ?? '';
  let error = '';
  if (mode === 'percentage') {
    try { calculatePlacementFee(salary, percent); }
    catch (issue) { error = issue.message; }
  }
  const update = (path, value) => {
    const patch = { [path]: value };
    if (path === FEE_PERCENT) patch[FEE_PERCENT_UNIT] = 'percent';
    const next = structuredClone(root);
    Object.entries(patch).forEach(([key, nextValue]) => putValue(next, key, nextValue));
    synchronizePlacementInputs(next, fields);
    try { applyPlacementCalculation(next, fields); }
    catch (_error) { if (getValue(next, FEE_MODE) === 'percentage') putValue(next, FEE_AMOUNT, ''); }
    PLACEMENT_DERIVED_PATHS.forEach(key => { if (getValue(next, key) !== undefined) patch[key] = getValue(next, key); });
    onChange(patch);
  };
  return <div className="ncf-placement-worksheet">
    <h4>Placement Fee</h4>
    <div className="ncf-review-grid">
      <label>Fee calculation<select value={mode} disabled={disabled} onChange={event => update(FEE_MODE, event.target.value)}>
        <option value="imported">Imported / manual amount</option><option value="percentage">Salary percentage</option><option value="flat">Flat fee</option>
      </select></label>
      {basis.hasPay && basis.hourly && <label>Hours per week<input type="number" min="0.01" max="168" step="0.25" value={getValue(root, HOURS_PER_WEEK) ?? 40} disabled={disabled} onChange={event => update(HOURS_PER_WEEK, event.target.value)} /></label>}
      <label>Annual placement salary<input type="number" min="0" step="0.01" value={salary} disabled={disabled} readOnly={basis.hasPay} onChange={event => update(PLACEMENT_SALARY, event.target.value)} /></label>
      <label>Placement fee percent<input type="number" min="0" max="100" step="0.01" value={percent} disabled={disabled || mode === 'flat'} onChange={event => update(FEE_PERCENT, event.target.value)} /></label>
      <label>Placement fee amount<input type="number" min="0" step="0.01" value={getValue(root, FEE_AMOUNT) ?? ''} disabled={disabled} readOnly={mode === 'percentage'} onChange={event => update(FEE_AMOUNT, event.target.value)} /></label>
    </div>
    {error && <div className="alert alert-error" role="alert">{error}</div>}
  </div>;
}